import register from "preact-custom-element";
import { IceFeedbackRibbon } from "./Ribbon/ice-feedback-ribbon";
import { IceFeedbackPopup } from "./Popup/ice-feedback-popup";

document.addEventListener("DOMContentLoaded", (): void => {
  register(IceFeedbackRibbon, "ice-feedback", ["style"]);
  register(IceFeedbackPopup, "ice-feedback-popup", ["show"]);
});
